module.exports = __webpack_public_path__ + "static/2-66a958bc02f29487be34de14bcd55487.png";